export const SIGN_IN_PAGE_SIGN_UP_SUGGESTION = 'sign-in-page.sign-up-suggestion';
export const SIGN_IN_PAGE_SIGN_UP_LINK = 'sign-in-page.sign-up-link';
